var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "arrow_forward_FILL0_wght300_GRAD200_opsz48",
  d: "M177.158-787.247H164v-1.478h13.157l-6.21-6.21L172-796l8,8-7.975,8-1.054-1.063Z",
  transform: "translate(-164.001 795.999)",
  fill: "#fff"
})));
export default __webpack_public_path__ + "static/media/rightarrow.85b77972.svg";
export { SvgComponent as ReactComponent };